import { MinimalWordGraph } from "word-graphs";
import wordList from "./wordsAlpha.json";

export const WordList = new MinimalWordGraph();
(wordList as any).words.sort().forEach((w: string) => WordList.add(w));
WordList.makeImmutable();
